import { removeLastSlash, removeLinkParams } from './link';
const baseVimeoPath = 'vimeo.com/';
const baseEmbeddedPath = 'https://player.vimeo.com/';
const createEmbeddedLink = (link) => {
    const paths = removeLastSlash(removeLinkParams(link))
        ?.split(baseVimeoPath)[1]
        .split('/');
    const finalPath = paths && paths.length > 0 ? `video/${paths[0]}` : undefined;
    return finalPath ? `${baseEmbeddedPath}${finalPath}` : undefined;
};
export const vimeo = {
    category: 'VIDEO',
    isSatisfied: (link) => link.includes(baseVimeoPath),
    getPlayerExecutionProps: (link) => ({
        link: createEmbeddedLink(link),
        allowProps: 'autoplay; fullscreen; picture-in-picture',
    }),
};
